export default __webpack_public_path__ + "img/jtc/jtc8_480.webp";